import { TrackingInfo as TrackingInfoMyAccountAreaDrawer } from "./TrackingInfoMyAccountAreaDrawer";
import { PageContextUtils } from "../../utils";

//TODO: When old user area is replaced by MyAccountArea, delete this file and replace TrackingInfoUserAreaDrawer by TrackingInfoMyAccountAreaDrawer in all files

const { myAccountAreaComponents } = PageContextUtils.getVisualData();

export const TrackingInfo = myAccountAreaComponents
  ? TrackingInfoMyAccountAreaDrawer
  : {
      dataCategory: "User Area Drawer",
      dataAction: "click",
      dataLabel: ""
    };
